import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './CollapsedText.css';

interface ICollapsedTextProps {
  text: React.ReactNode;
  expanded: boolean;
  collapsedHeight?: number;
  expandable: boolean;
}

export const CollapsedText = React.forwardRef<HTMLDivElement, ICollapsedTextProps>(
  ({ text, expanded, collapsedHeight = 0, expandable }, ref) => {
    return (
      <div
        data-name="CollapsedText"
        ref={ref}
        className={clsx({ [styles['collapsed']]: !expanded, [styles['expandable']]: expandable })}
        style={{ maxHeight: expanded ? 'none' : collapsedHeight }}
      >
        {text}
      </div>
    );
  },
);

CollapsedText.displayName = 'CollapsedText';
